import { FilterableList } from "../filterable-list";
import { FilterParameter } from "../models/types"


export class TeamMembersList extends FilterableList<TeamMember> {
	public constructor() {
		super(".team-section .card-list", '.no-results', '.filter-tabs');
	}
	createResult(dataItem: TeamMember): void {

		let template = document.querySelector('.team-section .template .card').cloneNode(true) as HTMLElement;
		var image = template.querySelector('.image') as HTMLElement;
		var name = template.querySelector('h3');
		
		var url = template.querySelector('a') as HTMLAnchorElement;
		var memberTitle = template.querySelector('.content span');
		if (dataItem.teamMemberImageUrl) {
			let cleanUrl = dataItem.teamMemberImageUrl.replace("~", "");
			image.style.backgroundImage = `url('${cleanUrl}')`;
			image.querySelector('.no-image').remove();
		}

		name.innerHTML = dataItem.teamMemberFullName;
		memberTitle.innerHTML = dataItem.teamMemberTitle;
	
		url.href = dataItem.pageUrl.replace("~", "");
		
		
		this.resultsWrapper.append(template);
	}

	clearResults(): void {
		if (this.resultsWrapper) {
			this.resultsWrapper.innerHTML = "";
		} }

	toggleLoader(isLoading: boolean): void {
		var loader = document.querySelector('.team-section .loader');
		if (loader) {
			if (isLoading) {
				loader.classList.remove('d-none');
			} else {
				loader.classList.add('d-none');
				this.resultsWrapper.classList.remove('d-none');
				this.paginationContainer.classList.remove('d-none');
			}
		}
	}

	onQueryChange(selectedFilters: FilterParameter[]): void {
	
		this.search("/team-members/list-search", selectedFilters, false); }
}

export interface TeamMember {
	pageUrl: string;
	pageTitle: string;
	teamMemberFullName: string;
	teamMemberImageUrl: string;
	teamMemberTitle: string;
	teamMemberPhone: string;
	teamMemberInfo: string;
	teamMemberFirstName: string;
	teamMemberLastName: string;
	teamMemberTwitterUrl: string;
	teamMemberEmail: string;
	teamMemberLinkedInUrl: string;
	teamMemberCategoryIds: number[];
}